/**
 * Mock Data Utilities
 * Provides fallback mock data for API services during development or failures
 */

/**
 * Mock activities data (temporary until backend endpoint is implemented)
 * @param {string} destination - Destination name
 * @returns {Array} Array of mock activities
 */
export function getMockActivities(destination) {
  return [
    {
      id: 1,
      name: `${destination} Coastal Hiking Trail`,
      category: 'Outdoor Activity',
      rating: 4.6,
      duration: '3-4 hours',
      price: 25,
      image_url: 'https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 2,
      name: `${destination} Snorkeling Adventure`,
      category: 'Water Activity',
      rating: 4.8,
      duration: '2-3 hours',
      price: 45,
      image_url: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 3,
      name: `${destination} Photography Tour`,
      category: 'Cultural',
      rating: 4.4,
      duration: '2 hours',
      price: 35,
      image_url: 'https://images.unsplash.com/photo-1471919743851-c4df8b6ee5c?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    }
  ];
}

/**
 * Mock accommodations data (temporary until backend endpoint is implemented)
 * @param {string} destination - Destination name
 * @returns {Array} Array of mock accommodations
 */
export function getMockAccommodations(destination) {
  return [
    {
      id: 1,
      name: `${destination} Beachfront Resort & Spa`,
      type: 'Resort',
      rating: 4.6,
      price_per_night: 280,
      distance: '0.2 km',
      image_url: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 2,
      name: `${destination} Coastal View Hotel`,
      type: 'Hotel',
      rating: 4.2,
      price_per_night: 150,
      distance: '0.4 km',
      image_url: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 3,
      name: `${destination} Lighthouse B&B`,
      type: 'Bed & Breakfast',
      rating: 4.8,
      price_per_night: 120,
      distance: '1.0 km',
      image_url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    }
  ];
}

/**
 * Mock restaurants data (fallback when API fails)
 * @param {string} destination - Destination name
 * @returns {Array} Array of mock restaurants
 */
export function getMockRestaurants(destination) {
  return [
    {
      id: 1,
      name: `${destination} Waterfront Dining`,
      cuisine: 'Seafood',
      rating: 4.5,
      price_level: '$$$',
      distance: '0.3 km',
      description: 'Fresh seafood with ocean views',
      image_url: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 2,
      name: `The Local Bistro - ${destination}`,
      cuisine: 'Australian',
      rating: 4.3,
      price_level: '$$',
      distance: '0.5 km',
      description: 'Local favorites and modern Australian cuisine',
      image_url: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 3,
      name: `${destination} Coffee & Co`,
      cuisine: 'Cafe',
      rating: 4.7,
      price_level: '$',
      distance: '0.2 km',
      description: 'Artisan coffee and fresh pastries',
      image_url: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    },
    {
      id: 4,
      name: `Sunset Grill - ${destination}`,
      cuisine: 'International',
      rating: 4.4,
      price_level: '$$',
      distance: '0.7 km',
      description: 'International cuisine with sunset views',
      image_url: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&w=300&h=300&fit=crop'
    }
  ];
}

/**
 * Generate mock flight data
 * @param {string} origin - Origin airport code
 * @param {string} destination - Destination airport code
 * @returns {Array} Array of mock flights
 */
export function getMockFlights(origin, destination) {
  return [
    {
      id: 1,
      airline: 'Jetstar',
      flight_number: 'JQ142',
      departure: '08:30',
      arrival: '12:45',
      duration: '4h 15m',
      price: 299,
      stops: 0
    },
    {
      id: 2,
      airline: 'Virgin Australia',
      flight_number: 'VA673',
      departure: '14:20',
      arrival: '18:50',
      duration: '4h 30m',
      price: 349,
      stops: 0
    },
    {
      id: 3,
      airline: 'Qantas',
      flight_number: 'QF891',
      departure: '19:15',
      arrival: '23:30',
      duration: '4h 15m',
      price: 459,
      stops: 0
    }
  ];
}

export default {
  getMockActivities,
  getMockAccommodations,
  getMockRestaurants,
  getMockFlights
};